import { graphDefault } from './';
export const graphBackFill = (theme, parameters) => {
  return {
    fillColor: graphDefault(theme, parameters).backgroundColor,
    frameBorder: false
  };
};
//# sourceMappingURL=graphBackFill.js.map